// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductItem_item__WYS0J","price":"ProductItem_price__1GiPR","actions":"ProductItem_actions__14Yr-"};